<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('projects.projectStateChange')"></page-title>
    </div>

    <jet-form-section @submitted="updateState()">

        <template #form>
            <!-- Card Project State -->
            <form-card :title="$t('projects.state')" :description="$t('projects.projectStateDescription')">

                <radio-list
                    v-model="form.updateState.state"
                    :items="states" />

            </form-card>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button"
                        class="inline-block uppercase font-semibold text-xs tracking-widest">{{ $t("actions.cancel") }}
                </button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>
            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import RadioList from "@/Shared/Components/RadioList";


const states = [
    { name: "Aktiv", description: "Dieses Projekt ist für jeden zugänglich, der den Link hat.", code: "active" },
    { name: "Abgeschlossen", description: "Nur Mitglieder dieses Projektes haben Zugang.", code: "completed" },
    { name: "Archiviert", description: "Sie sind der Einzige, der Zugang zu diesem Projekt hat.", code: "archived" }
];

export default defineComponent({
    props: ["project"],
    inheritAttrs: false,
    emits: ["closeModal"],
    layout: MainLayout,
    components: {
        PageTitle,
        FormCard,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        RadioList
    },
    data() {
        return {
            form: useForm({
                updateState: {
                    state: this.states.find(s => s.code === this.project.state)
                }
            })
        };
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        updateState() {
            this.form.updateState.state = this.form.updateState.state.code;
            this.form.post(this.route("advisors.projects.update", { project: this.project.uuid }), {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: "actions.success",
                    text: "projects.updated"
                })
            });
        }
    },
    setup() {
        return {
            states
        };
    }
});
</script>

<style scoped></style>
